export default "__VITE_ASSET__bhCl2vCP__"